import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AlertReportComponentType, AlertReportTemplate, CreateAlertReportRequest, ExportAlertReportRequest, GenerateAlertReportRequest, NotifyAlertReportRequest, PreviewAlertReportRequest } from '../models/alert-report-template.model';

export const AlertReportTemplateActions = createActionGroup({
  source: 'AlertReportTemplate',
  events: {
    loadTemplates: emptyProps(),
    loadTemplatesSuccess: props<{ templates: AlertReportTemplate[] }>(),
    loadTemplatesFailure: props<{ error: any }>(),
    loadComponentTypes: emptyProps(),
    loadComponentTypesSuccess: props<{ componentTypes: AlertReportComponentType[] }>(),
    loadComponentTypesFailure: props<{ error: any }>(),
    createTemplate: props<{ payload: CreateAlertReportRequest }>(),
    createTemplateSuccess: props<{ template: AlertReportTemplate }>(),
    createTemplateFailure: props<{ error: any }>(),
    resetCreate: emptyProps(),
    deleteTemplate: props<{ templateId: string }>(),
    deleteTemplateSuccess: props<{ templateId: string }>(),
    deleteTemplateFailure: props<{ error: any }>(),
    resetDelete: emptyProps(),
    previewTemplate: props<{ templateId: string; payload: PreviewAlertReportRequest }>(),
    previewTemplateSuccess: props<{ html: string }>(),
    previewTemplateFailure: props<{ error: any }>(),
    resetPreview: emptyProps(),
    // exportPayload, when present, chains a CSV export after the report download succeeds —
    // kept in the effect (not the dialog) so it survives the dialog being closed.
    generateReport: props<{ payload: GenerateAlertReportRequest; exportPayload?: ExportAlertReportRequest }>(),
    generateReportSuccess: emptyProps(),
    generateReportFailure: props<{ error: any }>(),
    resetGenerate: emptyProps(),
    notifyRecipients: props<{ payload: NotifyAlertReportRequest }>(),
    notifyRecipientsSuccess: props<{ recipientCount: number }>(),
    notifyRecipientsFailure: props<{ error: any }>(),
    resetNotify: emptyProps(),
    exportAlerts: props<{ payload: ExportAlertReportRequest }>(),
    exportAlertsSuccess: emptyProps(),
    exportAlertsFailure: props<{ error: any }>(),
    resetExport: emptyProps()
  }
});
